import { CommandSerializer } from './CommandSerializer';
import { Vehicle } from 'core/models/vehicle';
import { Project } from 'core/models/project';
import { DriveCommand } from 'core/models/drive';
import { controlModeToRemoteModeCode, toBlinkerCode, toGearCode } from '../DriveCommand';

export class DriveCommandSerializer implements CommandSerializer {
    private readonly options: { withTimestamp?: boolean };

    constructor(options: { withTimestamp?: boolean }) {
        this.options = options;
    }

    serialize(vehicleId: Vehicle.Id, projectId: Project.Id, command: DriveCommand): string {
        const withTimestamp = this.options.withTimestamp ?? false;

        const now = new Date();
        const timestamp = (now.getUTCMinutes() * 60 + now.getUTCSeconds()) * 1000 + now.getUTCMilliseconds();

        const payload = (withTimestamp
            ? [
                timestamp,
                controlModeToRemoteModeCode(command.controlMode),
                command.steering,
                command.accel,
                command.brake,
                toGearCode(command.gear),
                toBlinkerCode(command.blinker),
            ]
            : [
                command.steering,
                command.accel,
                command.brake,
                toGearCode(command.gear),
                toBlinkerCode(command.blinker),
                controlModeToRemoteModeCode(command.controlMode),
            ]).join(',');

        return JSON.stringify({
            type: 'DriveCommand',
            body: {
                'project_id': projectId,
                'vehicle_id': vehicleId,
                payload,
            },
        });
    }
}
